// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/produkte/special-compression-spring-with-solderable-surface/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const produkteSpecialCompressionSpringWithSolderableSurfaceEN: PageEntry = {
  id: "example.produkte-sonderdruckfeder-mit-loetbarer-oberflaeche",
  locale: "en",
  slug: "produkte/special-compression-spring-with-solderable-surface",
  seo: {
    title: "Special compression spring with solderable surface | Dietz GmbH",
    description: "Further processing in an SMT assembly and use of the boards in a wide variety of household appliances with touch fields. In addition to the high accuracy requirement, automatic fee",
  },
  type: "post",
  h1: "Special compression spring with solderable surface",
  intro: "Further processing in an SMT assembly and use of the boards in a wide variety of household appliances with touch fields. In addition to the high accuracy requirement, automatic feeding capability must be ensured.",
  blocks: [
    { kind: "image", src: "/images/live/DTZ_sonderdruckfeder.jpg", alt: "Special compression spring with solderable surface", width: 1400, height: 1120 }
  ],
};
